// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + "main" + "." + "3747f585af87971b58fe" + ".css";
};